export default "__VITE_PUBLIC_ASSET__923ebe54__"